import { useTranslation } from 'react-i18next';
import propTypes from 'prop-types';
import { MdFileDownload } from 'react-icons/md';
import CodeBlock from './components/CodeBlock';
import * as S from './styles';

const SnippetOutput = ({ snippet, logoUrl, bannerUrl }) => {
  const [t] = useTranslation('personalized-invite');

  return (
    <S.Wrapper>
      <S.Downloads>
        <S.DownloadLink href={logoUrl} download={snippet.logoFileName}>
          <MdFileDownload size={16} />
          {snippet.logoFileName}
        </S.DownloadLink>
        <S.DownloadLink href={bannerUrl} download={snippet.bannerFileName}>
          <MdFileDownload size={16} />
          {snippet.bannerFileName}
        </S.DownloadLink>
      </S.Downloads>
      <CodeBlock title={t('generator.output.imports')} code={snippet.imports} />
      <CodeBlock
        title={t('generator.output.definitions')}
        code={snippet.definitions}
      />
      <CodeBlock
        title={t('generator.output.map-entry')}
        code={snippet.mapEntry}
      />
      <CodeBlock
        title={t('generator.output.claude-request')}
        code={snippet.claudeRequest}
      />
    </S.Wrapper>
  );
};

SnippetOutput.propTypes = {
  snippet: propTypes.shape({
    imports: propTypes.string.isRequired,
    definitions: propTypes.string.isRequired,
    mapEntry: propTypes.string.isRequired,
    logoFileName: propTypes.string.isRequired,
    bannerFileName: propTypes.string.isRequired,
    claudeRequest: propTypes.string.isRequired,
  }).isRequired,
  logoUrl: propTypes.string.isRequired,
  bannerUrl: propTypes.string.isRequired,
};

export default SnippetOutput;
